import { JsonSchemaValidator } from "@common/json-schema-validator";
import { RtmpDestinationV2EntityRaw } from "../../interface";
import { rtmpDestinationV2EntityRaw } from "../../schema";
import { BaseEntity } from "../base.entity";

export class RtmpDestinationV2Entity extends BaseEntity<RtmpDestinationV2EntityRaw> {
  private static validator = JsonSchemaValidator.compile(
    rtmpDestinationV2EntityRaw
  );

  constructor(value: RtmpDestinationV2EntityRaw) {
    super(JsonSchemaValidator.assert(RtmpDestinationV2Entity.validator, value));
  }
}
